<template>
  <bcg-response-tab-test-view
    :status="status"
    :test="test"
    :result="result">
    <bcg-response-tab-test-category
      v-for="category_result in category_results"
      :key="category_result.id"
      :category="category_result"/>
    <bcg-response-tab-test-block
      v-for="block_result in block_results"
      :key="block_result.id"
      :block="block_result"/>
    <bcg-response-tab-test-questions :questions="question_results"/>
    <bcg-response-tab-test-screenshots/>
  </bcg-response-tab-test-view>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex';
  import {STORE_PREFIX} from '../constants.js';
  import BcgResponseTabTestView from '../components/response-tab-test-view';
  import BcgResponseTabTestBlock from '../components/block';
  import BcgResponseTabTestQuestions from '../components/questions';
  import BcgResponseTabTestScreenshots from './screenshots';
  import BcgResponseTabTestCategory from "@/process/bcg-test/components/response/tabs/test/components/category";

  const {mapGetters} = createNamespacedHelpers(STORE_PREFIX + 'response_tab_test');

  export default {
    name: 'bcg-response-tab-test',
    components: {
      BcgResponseTabTestCategory,
      BcgResponseTabTestQuestions,
      BcgResponseTabTestBlock,
      BcgResponseTabTestScreenshots,
      BcgResponseTabTestView},
    computed: {
      ...mapGetters(['result', 'category_results', 'block_results', 'question_results', 'test', 'status'])
    }
  }
</script>
